import { webProxy } from '@/core/eventProxy';
import type { ISetupConf } from '@/types/setup.ts';
export class WebSetup {
  private config: ISetupConf | null = null;
  public constructor(config) {
    console.log('webSetup:  ', config);
    this.config = config;
    if (!config.webMode || config.webMode === 'spa') {
      this.setAppTrack();
    }
    this.setPageTrack();
  }
  private setPageTrack() {
    if (this.config?.Vue?.router) {
      const _router = this.config.Vue.router;
      _router.beforeEach((to, from) => {
        console.group('beforeEach: ');
        console.log('to: ', to);
        console.log('from: ', from);
        console.log('url: ', location, location.href);
        console.groupEnd();
      });
      _router.afterEach((to, from) => {
        console.group('afterEach: ');
        console.log('to: ', to);
        console.log('from: ', from);
        console.log('url: ', location, location.href);
        console.groupEnd();
        if (from?.matched?.length) {
          webProxy.Page.onLeave({
            pageName: `${location.origin}${from.href.split('?')[0]}`,
          });
        }
        webProxy.Page.onShow();
      });
    }
    // todo：
  }
  private setAppTrack() {
    webProxy.App.onLaunch();
  }
}

export default WebSetup;
